import { divIcon } from "leaflet";
import React from "react";
import { Marker, Tooltip } from "react-leaflet";

export default function BidRoadRestrictions({ route, filters = {} }) {
    if (!route) {
        return null;
    }
    const roadRestrictions = route.segments.reduce((acc, item) => [...acc, ...(item.roadRestrictions ?? [])], []);
    return roadRestrictions.map((item, i) => {
        if (filters[item.type.id] != null && !filters[item.type.id]) {
            return null;
        }

        return <BidRoadRestriction key={i} item={item} />;
    });
}

const BidRoadRestriction = (props) => {
    const { location, name, description, type } = props.item;
    const icon = divIcon({
        html: `<img src="${type.iconUrl}" width="26" height="26" />`,
        className: "map-icon--bid-road-restriction",
        iconSize: [26, 26],
    });
    if (!location) {
        return null;
    }
    return (
        <Marker position={[...location].reverse()} icon={icon} zIndexOffset={50}>
            <Tooltip
                className="map__tooltip-road-restrictions leaflet-tooltip--left-align leaflet-tooltip--light"
                direction="top"
            >
                <div className="font-weight-bold">{type.name}</div>
                <div>{name}</div>
                <div className="small">{description}</div>
            </Tooltip>
        </Marker>
    );
};
